export function getRequest(params) {
    var url = buildUrl(params.url, params.params || {});
    return new Promise(function (res, rej) {
        var xhr = new XMLHttpRequest();
        xhr.open('get', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    var data = getDataFromResponse(this.response);
                    res({
                        status: this.status,
                        data: data,
                    });
                }
                else {
                    rej({
                        status: this.status,
                        data: getDataFromResponse(this.response),
                    });
                }
            }
        };
        xhr.send();
    });
}
function getDataFromResponse(response) {
    try {
        return JSON.parse(response);
    }
    catch (e) {
        return response;
    }
}
function buildUrl(url, params) {
    var serializedParams = params
        ? Object.keys(params)
            .map(function (key) {
            return (encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
        })
            .join('&')
        : null;
    return serializedParams ? url + "?" + serializedParams : url;
}
//# sourceMappingURL=request.js.map